import { DatapointOptions } from 'owa-analytics-actions';
import { MillisecondsInOneDay } from 'mini-datetime-utils/lib/dateValues/constants';
import { trackWorkflow } from 'mini-app-context/lib/utils/workflowUtils';
import {
    OCV_FEEDBACK_FORM_DISMISSED,
    OCV_FEEDBACK_FORM_LAUNCHED,
    OCV_FEEDBACK_FORM_SUBMITTED,
    OCV_FEEDBACK_LAUNCH_BEGIN,
    OCV_FEEDBACK_LAUNCH_ERROR,
    OCV_FEEDBACK_LAUNCH_RETRY_CLICK,
} from './eventSignalConstants';

let isOCVFeedbackWorkFlowAdded: boolean = false;

export const registerWorkflowsForOCVFeedback = () => {
    if (isOCVFeedbackWorkFlowAdded) {
        return;
    }

    trackWorkflow<DatapointOptions>([
        {
            name: 'WF_OCVFeedback',
            start: OCV_FEEDBACK_LAUNCH_BEGIN,
            checkmarks: [OCV_FEEDBACK_FORM_LAUNCHED, OCV_FEEDBACK_LAUNCH_RETRY_CLICK],
            end: [
                OCV_FEEDBACK_LAUNCH_ERROR,
                OCV_FEEDBACK_FORM_DISMISSED,
                OCV_FEEDBACK_FORM_SUBMITTED,
            ],
            options: { isCore: true, timeout: MillisecondsInOneDay },
        },
    ]);

    isOCVFeedbackWorkFlowAdded = true;
};
